var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDeleteBtnWhitea78Eaa4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2197",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52043",
    "data-name": "Group 52043",
    transform: "translate(-1278 -280)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1278, 280)",
    filter: "url(#Ellipse_2197)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2197-2",
    "data-name": "Ellipse 2197",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_108_9",
    "data-name": "Component 108 \\u2013 9",
    transform: "translate(1298 298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45599",
    "data-name": "Group 45599",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34519",
    "data-name": "Path 34519",
    d: "M5,8H19",
    fill: "none",
    stroke: "#ff4848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36285",
    "data-name": "Path 36285",
    d: "M17,8v9.625A1.4,1.4,0,0,1,15.577,19H8.464a1.4,1.4,0,0,1-1.422-1.375V8",
    fill: "none",
    stroke: "#ff4848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36286",
    "data-name": "Path 36286",
    d: "M9,8V6.5A1.5,1.5,0,0,1,10.5,5h3A1.5,1.5,0,0,1,15,6.5V8",
    fill: "none",
    stroke: "#ff4848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    y2: 4,
    transform: "translate(10 12)",
    fill: "none",
    stroke: "#ff4848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    y2: 4,
    transform: "translate(14 12)",
    fill: "none",
    stroke: "#ff4848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19798",
    "data-name": "Rectangle 19798",
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDeleteBtnWhitea78Eaa4A);
export default __webpack_public_path__ + "static/media/ico-delete-btn-white.a78eaa4a.0416a724b8fc49111b17b48669651af9.svg";
export { ForwardRef as ReactComponent };